<div class="content">

    <div class="tlr-workorder-container">

        <div class="section-title">Find TLR's Given a Work Order Report
        </div>
        <div class="partioned-table">
            <div class="row">
                <div class="cell label label-text">Enter Maximo Work Order Number
                </div>
                <div class="cell value AreaBlue p-1-0 m-left">
                    <input name="maximo order" type="text" (keydown.enter)="searchTag()"  id="contentContent_txtBlueTag"  [(ngModel)]="orderNumber"  class="inputArea">
                    <button class="search-btn" (click)="searchTag()" >Search Tag</button>
                </div>
            </div>
        </div>
       
    </div>
    
    <div *ngIf="showTable" class="table-chart-container mt-10">
        <div class="exportToExcel excel-btn" >
            <div class="actions">
                <button pButton type="button" label="Export To Excel" icon="pi pi-file-excel" class="p-button-outlined" (click)="exportToExcel()">Export To Excel</button>
              </div>
            </div>
            <div class="report-content section-wrapper">
                <p-table [value]="trlWorkOrderNumber" [paginator]="true"  [rows]="10" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Tag Number</th>
                        <th>Entry Date</th>
                        <th>Oper User ID</th>
                        <th>Division</th>
                        <th>Section</th>
                        <th>Plant</th>
                        <th>LDAR</th>
                        <th>Op. PSI</th>
                        <th>Op. Temp</th>
                        <th>ShutdownDescription</th>
                        <th>Service </th>
                        <th>Insp User ID</th>
                        <th>Service Class</th>
                        <th>OA User ID</th>
                        <th>Permanent Repair Date</th>
                        <th>Eng User ID</th>
                        <th>TLR Type</th>
                        <th>Maximo WO Number</th>
                        <th>Maximo Outage- T/A</th>
            
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-detail>
                      <tr let detail of inspectorCaiReportData>
                        <td><a routerLink="/details-section/{{detail.Tag_Number}}">
                            {{ detail.Tag_Number }}</a></td>
                        <td>{{detail.Data_Entry_Date | date:'MM/dd/yyyy'}}</td>
                        <td>{{detail.Operator_CAI}}</td>
                        <td>{{detail.Division}}</td>
                        <td>{{detail.Section}}</td>
                        <td>{{detail.Plant}}</td>
                        <td>{{detail.LDAR}}</td>
                        <td>{{detail.Oper_PSI}}</td>
                        <td>{{detail.Oper_Temp}}</td>
                        <td>{{detail.ShutdownDescription}}</td>
                        <td>{{detail.Service}}</td>
                        <td>{{detail.InspectionCAI}}</td>
                        <td>{{detail.ServiceClass}}</td>
                        <td>{{detail.OACAI}}</td>
                        <td class="{{commonService.getDateColorClass(detail.Permanent_Repair_Date)}}">{{detail.Permanent_Repair_Date | date:'MM/dd/yyyy'}}</td>
                        <td>{{detail.EngineeringCAI}}</td>
                        <td>{{detail.TLRType}}</td>
                        <td>{{detail.Maximo_WO_Number}}</td>
                        <td>{{detail.Maximo_Outage_T_A}}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="17">No records found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
            </div>
 
    </div>

</div>